import _ from 'lodash';
import { IValidationCollection, IValidationResult, SeverityType } from '../models';

export class ValidationCollectionHelper<T> {
	private validationResults: IValidationCollection = {};
	private keys: { [normalizedKey: string]: string };

	constructor(validationResults?: IValidationCollection) {
		this.validationResults = validationResults || {};

		this.NormalizeKey = this.NormalizeKey.bind(this);

		const keys = _.keys(this.validationResults);
		this.keys = {};
		_.each(keys, (key: string) => (this.keys[this.NormalizeKey(key)] = key));
	}
	public NormalizeKey(key: any) {
		return key.toString().toLowerCase();
	}
	public GetKey(normalizedKey: string) {
		return this.keys[normalizedKey];
	}

	public IsValid(key?: T) {
		if (!key) {
			return _.every(this.validationResults, (vr: IValidationResult) => vr.isValid);
		}
		const normalizedKey = this.NormalizeKey(key);
		const referenceKey = this.GetKey(normalizedKey);
		if (_.has(this.keys, normalizedKey)) {
			return this.validationResults[referenceKey].isValid;
		}
		return true;
	}
	public Errors(key: T) {
		const normalizedKey = this.NormalizeKey(key);
		const referenceKey = this.GetKey(normalizedKey);
		if (_.has(this.keys, normalizedKey)) {
			return this.validationResults[referenceKey].errors || [];
		}
		return [];
	}

	public GetValidationMessages(type: SeverityType) {
		if (_.isEmpty(this.validationResults)) {
			return [];
		}

		let messages: string[] = [];
		switch (type) {
			case SeverityType.Error:
				Object.keys(this.validationResults).forEach((key) => {
					const errors = this.validationResults[key].errors;
					if (errors !== undefined && errors.length > 0) {
						messages = messages.concat(errors);
					}
				});
				break;
			case SeverityType.Warning:
				Object.keys(this.validationResults).forEach((key) => {
					const warnings = this.validationResults[key].warnings;
					if (warnings !== undefined && warnings.length > 0) {
						messages = messages.concat(warnings);
					}
				});
				break;
		}
		return messages;
	}

	public GetValidationResultForProperty(property: T): IValidationResult | undefined {
		const normalizedKey = this.NormalizeKey(property);
		const key = this.GetKey(normalizedKey);
		if (Object.prototype.hasOwnProperty.call(this.validationResults, key)) {
			return this.validationResults[key];
		}
		return undefined;
	}
}

export class ValidationResultHelper {
	private validationResult: IValidationResult = { isValid: false };

	constructor(validationResult?: IValidationResult) {
		this.validationResult = validationResult || { isValid: false };
	}
	public PropertyWarnings(key?: number) {
		if (
			!this.validationResult ||
			!key ||
			!this.validationResult.propertyWarnings ||
			!Object.prototype.hasOwnProperty.call(this.validationResult.propertyWarnings, key)
		) {
			return [];
		}
		return this.validationResult.propertyWarnings[key] || [];
	}

	public PropertyErrors(key?: number) {
		if (
			!this.validationResult ||
			!key ||
			!this.validationResult.propertyErrors ||
			!Object.prototype.hasOwnProperty.call(this.validationResult.propertyErrors, key)
		) {
			return [];
		}
		return this.validationResult.propertyErrors[key] || [];
	}
}
